<template>
  <CommonLayout header="customerHeader" footer="customerFooter">
    <CustomerMeetingLayout :type="consts.meetingType.customer" :itemInfo="itemInfo" :totalShow="totalShow" :customerDisplayFlag="customerDisplayFlag" ref="CustomerMeetingLayout" @changeIsOperationPossible="changeIsOperationPossible">
      <div class="base-color overflow-auto shadow">
        <BOverlay :show="overlayShow" rounded="sm">
          <div class="p-2">
            <!--<div class="col-sm-12 row p-3" v-if="!isReDrawMemoImage">-->
            <!--  <span>以下の商品でよろしければ、決定ボタンを押してください。</span>-->
            <!--</div>-->
            <div class="col-sm-12" v-show="!showCanvas">
              <ProductSelectionSlider v-if="projectImages.length > 0" :projectImages="projectImages" :showBookmarkIcon="false" @sendSignaling="sliderSendSignaling" @slideChanged="onSlideChanged"/>
              <div class="col-12 col-sm-12 row mt-2 mb-3 pe-0" v-if="!isReDrawMemoImage">
                <div class="col-6 col-sm-6 text-end">
                  <BButton v-if="fromBookmark !== 'true'" variant="outline-primary" class="sub-button-color" id="back" @click="backPage">&lt;&nbsp;戻る</BButton>
                </div>
              </div>
            </div>
            <div class="col-sm-12 text-center" v-show="showCanvas">
              <img :style="{height: memoImageHeight + 'px'}" style = "width: 100%; object-fit: contain;" :src="memoImage">
            </div>
            <div id="operationInvalidOverlay" v-if="operationInvalidOverlay">
            </div>
          </div>
        </BOverlay>
      </div>
    </CustomerMeetingLayout>
    <CommonModal ref="commonModal" />
  </CommonLayout>
</template>
<script>
import CommonLayout from '@/layout/CommonLayout'
import CustomerMeetingLayout from '@/layout/CustomerMeetingLayout'
import ProductSelectionSlider from '@/components/ProductSelectionSlider'
import CommonModal from '@/components/CommonModal'
import ProjectDetailModel from '@/models/ProjectDetailModel'
import MemoImageModel from '@/models/MemoImageModel'
import SignalingModel from '@/models/SignalingModel'
import MeetingInfoUpdateModel from '@/models/MeetingInfoUpdateModel'
import CommonLogModel from '@/models/CommonLogModel'
import mstore from '@/store/meeting-store'
import cstore from '@/store/customer-store'
import fstore from '@/store/florist-store'

export default {
  name: 'CustomerMeetingProductSelection',
  components: { CommonLayout, CustomerMeetingLayout, ProductSelectionSlider, CommonModal },
  data () {
    return {
      isOperationPossible: true,
      overlayShow: false,
      isSendFirstSignalingData: false,
      projectImages: [],
      currentSlideIndex: 0,
      currentSlideImage: null,
      showCanvas: false,
      memoImage: '',
      memoImageHeight: 0,
      operationInvalidOverlay: false,
      isMainGuest: false,
      isReDrawMemoImage: false,
      suggestionType: '',
      prevEvent: '',
      routeProjectType: '',
      routeTableRowId: '',
      routeId: '',
      itemInfo: [],
      totalShow: fstore.getters.totalShow === null ? false : fstore.getters.totalShow,
      customerDisplayFlag: cstore.getters.customerDisplayFlag === null ? false : cstore.getters.customerDisplayFlag,
      fromBookmark: false,
      routeSuggestionType: '',
      fromProductProposal: false
    }
  },
  computed: {
    getIsTargetAtendeeActive () {
      // フローリストとの疎通確立フラグ取得
      return mstore.getters.isTargetAtendeeActive
    },
    getSignalingData () {
      return cstore.getters.signalingReceiveData
    }
  },
  watch: {
    getIsTargetAtendeeActive: function (newData, oldData) {
      if (!this.isSendFirstSignalingData && mstore.getters.isTargetAtendeeActive) {
        this.isSendFirstSignalingData = true

        // 接続確立しmeetingSessionが確立した後に要求を送る
        if (sessionStorage.getItem('lastRoutePath') === this.$route.path) {
          // 画面リロード時に情報の再送要求
          SignalingModel.sendAgainEvent()
        }
      }
    },
    getSignalingData: function (newData, oldData) {
      try {
        newData['user'] = 'customer'
        newData['timestampMs'] = Date.now()
        CommonLogModel.apiSetStore(this.$refs.commonModal, newData, () => {
        })
        console.log('getSignalingData()')
        console.log('newData ↓')
        console.log(newData)

        if (newData['event'] === 'again') {
          SignalingModel.sendClickEvent(this.prevEvent, this)
          return null
        }

        if (newData['id'] !== 'reDrawMemoImage' && newData['current_path'] && oldData) {
          const synchPass = newData['current_path'].replace('florist', 'customer')
          if (synchPass !== this.$route.path) {
            return this.$router.push(synchPass)
          }
        }

        if (newData['event'] === 'click') {
          if (newData['id'] === 'next') {
            // 画面遷移時に商品一覧のスクロール位置を削除
            sessionStorage.removeItem('proposalScrollHistoryFlag')
            sessionStorage.removeItem('scrollY')
            this.$router.push({path: newData['target_path'], query: {'projectType': localStorage.currentProjectType, 'suggestionType': localStorage.suggestionType}})
          } else if (newData['id'] === 'back') {
            if (sessionStorage.customerType === this.consts.customerType.guest || sessionStorage.customerType === this.consts.customerType.main) {
              const customerTargetPath = newData['target_path'].replace('florist', 'customer')
              this.$router.push(customerTargetPath)
            } else {
              this.$router.push(newData['target_path'])
            }
          } else if (newData['id'] === 'openCanvas') {
            this.showCanvas = true
            if (!this.memoImageHeight) this.memoImageHeight = 600
            if (newData['memoImageSrc']) {
              // 画像ソースがS3パスの場合
              this.memoImage = newData['memoImageSrc']
            } else {
              // 画像ソースがbase64の場合
              this.setMemoImage(newData['projectType'], newData['imageNumber'], newData['tableRowId'], false)
            }
          } else if (newData['id'] === 'closeCanvas') {
            this.showCanvas = false
          } else if (newData['id'] === 'showMemoImage') {
            this.showCanvas = true
            this.setMemoImage(newData['projectType'], newData['imageNumber'], newData['tableRowId'], true)
          } else if (newData['id'] === 'reDrawMemoImage') {
            localStorage.currentProjectType = newData['projectType']
            localStorage.suggestionType = newData['suggestionType']
            this.suggestionType = newData['suggestionType']
            this.routeId = newData['projectNumber']
            const targetPath = '/customer/meeting/product_selection/' + this.routeId
            const tableRowId = 'tableRowId' in newData && newData['tableRowId'] ? newData['tableRowId'] : ''
            if (this.routeProjectType === undefined || this.routeProjectType !== newData['projectType'] || targetPath !== this.$route.path) {
              if (newData['projectType'] && newData['projectType'] === 'お客様画像') {
                cstore.commit('setIsOperationPossible', false)
              }
              this.$router.push({path: targetPath, query: {'projectType': newData['projectType'], 'tableRowId': tableRowId}})
            } else {
              this.$router.push({path: this.$route.path, query: {'projectType': newData['projectType'], 'tableRowId': tableRowId}})
            }
            this.showCanvas = false
            this.isReDrawMemoImage = true
            this.setProjectImages(newData['projectType'], tableRowId)
          } else if (newData['id'] === 'selectProject') {
            this.setProjectImagesBeforeSelected(localStorage.currentProjectType)
            this.isReDrawMemoImage = true
          } else {
            let elm = document.getElementById(newData['id'])
            if (elm) {
              console.log(newData['id'])
              elm.click()
            }
          }
          if (sessionStorage.customerType !== this.consts.customerType.guest) {
            if (newData['id'] === 'operationInvalid') {
              cstore.commit('setIsOperationPossible', false)
              this.operationInvalidOverlay = true
            } else if (newData['id'] === 'operationPossible') {
              cstore.commit('setIsOperationPossible', true)
              this.operationInvalidOverlay = false
            }
          }

          if (newData['id'] === 'reDrawMemoImage') {
            if (this.routeProjectType === 'お客様画像') {
              cstore.commit('setIsOperationPossible', false)
              this.operationInvalidOverlay = true
            }
          }

          if (newData['id'] === 'priceHide') {
            cstore.commit('setCustomerDisplayFlag', false)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          } else if (newData['id'] === 'priceDisplay') {
            cstore.commit('setCustomerDisplayFlag', true)
            this.customerDisplayFlag = cstore.getters.customerDisplayFlag
          }

          if (newData['id'] === 'registBookmark') {
            for (const i in this.projectImages) {
              if (this.projectImages[i]['imageNumber'] === newData['imageNumber']) {
                this.projectImages[i]['bookmark'] = true
                break
              }
            }
          }

          if (newData['id'] === 'productDetailFromBookmark') {
            localStorage.currentProjectType = newData['projectType']
            localStorage.suggestionType = newData['suggestionType']
            this.suggestionType = newData['suggestionType']
            this.routeId = newData['projectNumber']
            const targetPath = '/customer/meeting/product_selection/' + this.routeId
            this.$router.push({path: targetPath, query: {'projectType': newData['projectType'], 'suggestionType': newData['suggestionType'], 'fromBookmark': true}})

            this.showCanvas = false
            this.isReDrawMemoImage = false
          }
        }

        if (!cstore.getters.isOperationPossible) {
          if (newData['event'] === 'api') {
            this.showCanvas = false
            if (newData['api'] === 'totalShow') {
              this.totalShow = newData['data']['totalShow']
            }
          }
        }
        if (newData['event'] === 'input') {
          this.$refs.CustomerMeetingLayout.changePriceAndQuantity(newData)
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    }
  },
  methods: {
    setProjectImages: async function (projectType, tableRowId = '') {
      try {
        this.overlayShow = true
        this.projectImages = []

        const params = { projectType, isSelected: 'True', suggestionType: this.suggestionType, tableRowId }
        const res = await ProjectDetailModel.apiSetStore(this.$refs.commonModal, this.routeId, params, () => {
          this.overlayShow = false
        })

        const images = Object.values(res?.projects?.images ?? {})
        const type2 = images.find(v => v.imageNumber === '2')
        const type3 = images.find(v => v.imageNumber === '3')

        if (this.suggestionType === 'main') {
          this.projectImages = type2 ? [type2] : []
        } else if (this.suggestionType === 'guest') {
          this.projectImages = type3 ? [type3] : []
        } else {
          this.projectImages = images
        }

        this.currentSlideIndex = 0
        this.currentSlideImage = this.projectImages[0] ?? null

        this.setItemInfo()
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, { timestampMs: Date.now(), error: err }, () => {})
      }
    },
    setProjectImagesBeforeSelected: async function (projectType) {
      try {
        this.overlayShow = true
        this.projectImages = []

        const params = { projectType, isSelected: 'False', suggestionType: this.suggestionType }
        const res = await ProjectDetailModel.apiSetStore(this.$refs.commonModal, this.routeId, params, () => {
          this.overlayShow = false
        })

        const images = Object.values(res?.projects?.images ?? {})
        const type2 = images.find(v => v.imageNumber === '2')
        const type3 = images.find(v => v.imageNumber === '3')

        if (['mainopt', 'guestopt', 'main', 'guest'].includes(this.suggestionType)) {
          this.isMainGuest = false
        }
        if (this.suggestionType === 'main') {
          this.projectImages = type2 ? [type2] : []
        } else if (this.suggestionType === 'guest') {
          this.projectImages = type3 ? [type3] : []
        } else {
          this.projectImages = images
        }

        this.currentSlideIndex = 0
        this.currentSlideImage = this.projectImages[0] ?? null

        this.setItemInfo()
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, { timestampMs: Date.now(), error: err }, () => {})
      }
    },
    setMemoImage: async function (projectType, imageNumber, tableRowId, isShowMemoImage) {
      try {
        this.overlayShow = true
        const params = {
          'projectType': projectType,
          'imageNumber': imageNumber,
          'itemCode': this.routeId,
          'isTmp': this.isReDrawMemoImage ? 0 : 1,
          'suggestionType': this.suggestionType,
          'tableRowId': tableRowId
        }
        const res = await MemoImageModel.apiSetStore(this.$refs.commonModal, params, () => {
          this.overlayShow = false
        })
        if (isShowMemoImage && res.images) {
          // お客様に見せるボタンが押された場合は、表示されたかどうかをフローリストに返す
          SignalingModel.sendStatusEvent({'show_memo_image': 'success'})
        }
        this.memoImage = res.images
        this.projectImages = this.projectImages.map(v => {
          if (String(v.imageNumber) === String(imageNumber)) {
            return { ...v, imagePath: this.memoImage }
          }
          return v
        })
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    setItemInfo () {
      try {
        const store = ProjectDetailModel.getStore()
        console.log(store)
        if (!store) {
          return null
        }
        this.itemInfo = store.projects.itemInfo
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    sliderSendSignaling (id) {
      try {
        console.log(this.prevEvent, id)
        if (id !== this.prevEvent) {
          this.prevEvent = id
          if (cstore.getters.isOperationPossible) {
            SignalingModel.sendClickEvent(id, this)
          }
        }
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    backPage () {
      try {
        const targetPath = '/customer/meeting/product_proposal'
        SignalingModel.sendClickEvent('back', this, {'target_path': targetPath.replace('customer', 'florist')})
        this.$router.push(targetPath)
      } catch (err) {
        CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
        })
      }
    },
    changeIsOperationPossible (value) {
      this.isOperationPossible = value
    },
    onSlideChanged (payload) {
      this.currentSlideIndex = payload?.index ?? 0
      this.currentSlideImage = payload?.image ?? null
      if (payload?.imageElHeight) this.memoImageHeight = payload.imageElHeight
    }
  },
  mounted () {
    try {
      // スクロール位置を一番上にする
      window.scrollTo(0, 0);
      this.fromBookmark = this.$route.query.fromBookmark
      this.routeProjectType = this.$route.query.projectType
      this.routeTableRowId = this.$route.query.tableRowId
      this.routeId = this.$route.params.id
      this.routeSuggestionType = this.$route.query.suggestionType
      this.fromProductProposal = this.$route.query.fromProductProposal

      this.suggestionType = localStorage.suggestionType
      if (this.fromBookmark === 'true') {
        this.setProjectImagesBeforeSelected(localStorage.currentProjectType)
        this.isMainGuest = this.consts.projectType.main.indexOf(localStorage.currentProjectType) !== -1
        this.isReDrawMemoImage = false
        localStorage.currentProjectType = this.routeProjectType
        localStorage.suggestionType = this.routeSuggestionType
      } else {
        if (this.routeProjectType !== undefined && this.fromProductProposal != 'true') {
          this.setProjectImages(this.routeProjectType, this.routeTableRowId)
          this.isMainGuest = this.consts.projectType.main.indexOf(this.routeProjectType) !== -1
          this.isReDrawMemoImage = true
        } else {
          this.setProjectImagesBeforeSelected(localStorage.currentProjectType)
          this.isMainGuest = this.consts.projectType.main.indexOf(localStorage.currentProjectType) !== -1
          this.isReDrawMemoImage = false
        }
      }

      if (this.routeProjectType && this.routeProjectType === 'お客様画像' &&
        sessionStorage.getItem('lastRoutePath') !== this.$route.path
      ) {
        cstore.commit('setIsOperationPossible', false)
        this.operationInvalidOverlay = true

        // 権限の情報をdynamoDBに登録
        const updateData = {
          'operatingPrivilege': '0',
          'attendeeType': this.consts.attendeeType.customer
        }
        MeetingInfoUpdateModel.apiSetStore(this.$refs.commonModal, updateData, () => {})
      }

      if (!cstore.getters.isOperationPossible) {
        this.operationInvalidOverlay = true
      }
    } catch (err) {
      CommonLogModel.apiSetStore(this.$refs.commonModal, {'timestampMs': Date.now(), 'error': err}, () => {
      })
    }
  }
}
</script>
<style>
#operationInvalidOverlay{
  position: absolute;
  left: 0; top: 0;
  width: 100%; height: 100%;
  opacity: 0;
  z-index: 2;
}
</style>
